import React from "react";
import * as LineChart from "./LineChart";
import * as BarChart from "./BarChart";
import * as BooleanWidget from "./BooleanWidget";
import * as TextWidget from "./TextWidget";
import * as TrackerWidget from "./TrackerWidget";
import * as GaugeWidget from "./GaugeWidget";
import * as LocationWidget from "./LocationWidget";
import { Template } from "../models";
import { DataStore } from "../state";
import { WidgetDetails } from "./models";
import { EditFormProps } from "../WidgetEditForm";
import * as ClusterBarWidget from "./ClusterBar";

export const DETAILS: WidgetDetails[] = [
  BarChart.details,
  BooleanWidget.details,
  GaugeWidget.details,
  LineChart.details,
  TextWidget.details,
  TrackerWidget.details,
  LocationWidget.details,
  ClusterBarWidget.details
];

// Combining the different widget types allows Typescript to use
// discriminated unions to provide more type safety.
export type WidgetConfig =
  | LineChart.Config
  | BarChart.Config
  | BooleanWidget.Config
  | TextWidget.Config
  | TrackerWidget.Config
  | GaugeWidget.Config
  | LocationWidget.Config
  | ClusterBarWidget.Config;

export function createWidget(
  config: WidgetConfig,
  common: { template: Template; data: DataStore,rightYAxisData:DataStore },
  errorCode: string | undefined
): JSX.Element {
  switch (config.type) {
    case "line":
      return <LineChart.Widget {...config} {...common} errorCode={errorCode} />;
    case "bar":
      return <BarChart.Widget {...config} {...common} />;
    case "boolean":
      return <BooleanWidget.Widget {...config} {...common} />;
    case "text":
      return <TextWidget.Widget {...config} {...common} />;
    case "tracker":
      return <TrackerWidget.Widget {...config} {...common} />;
    case "gauge":
      return <GaugeWidget.Widget {...config} {...common} />;
    case "map":
      return <LocationWidget.Widget {...config} {...common} />;
    case "clusterbar":
      return <ClusterBarWidget.Widget {...config} {...common} />;
  }
}

export interface EditForm {
  form: JSX.Element;
  parser: (a: any) => WidgetConfig | undefined;
}

export function getEditForm(
  type: WidgetConfig["type"]
): React.FC<EditFormProps> {
  switch (type) {
    case "bar":
      return BarChart.EditForm;
    case "boolean":
      return BooleanWidget.EditForm;
    case "gauge":
      return GaugeWidget.EditForm;
    case "line":
      return LineChart.EditForm;
    case "text":
      return TextWidget.EditForm;
    case "tracker":
      return TrackerWidget.EditForm;
    case "map":
      return LocationWidget.EditForm;
    case "clusterbar":
      return ClusterBarWidget.EditForm;
    default:
      return (props: EditFormProps) => <></>;
  }
}
